<div class="qr-container">
  <!-- GENERATOR -->
  <section *ngIf="mode === 'generator'" class="qr-panel qr-generator">
    <input
      type="text"
      placeholder="Enter text or URL"
      [(ngModel)]="inputValue"
    />

    <button
      class="primary action-btn"
      [disabled]="!inputValue.trim() || inputValue.length > 300"
      (click)="generateQr()"
    >
      Generate QR
    </button>

    <!-- Error message box -->
    <div *ngIf="inputValue.length > 300" class="validation-error">
      Text or URL length must be less then 300 characters!
    </div>

    <!-- QR RESULT -->
    <div *ngIf="generatedValue" class="qr-card">
      <span class="close" (click)="clearQr()">✕</span>

      <qrcode [qrdata]="generatedValue" [width]="200"> </qrcode>

      <div class="qr-actions">
        <button (click)="downloadQr()">Download</button>
        <button (click)="shareQr()">Share</button>
      </div>
    </div>
  </section>
</div>

<app-loader-overlay
  *ngIf="loading"
  [message]="'Generating link...'"
></app-loader-overlay>
<app-faq [items]="faqItems"></app-faq>
